<template>
    <div>
        <h1>{{type}}</h1>
        <classes v-if="type=='Classes'"></classes>
        <races v-if="type=='Races'"></races>
        <perks v-if="type=='Perks'" :perkList="perkList"></perks>
        <feats v-if="type=='Feats'"></feats>
        <weapons v-if="type=='Weapons'"></weapons>
        <armor v-if="type=='Armor'"></armor>
        <weapon-enchantments v-if="type=='Weapon Enchantments'"></weapon-enchantments>
        <armor-enchantments v-if="type=='Armor Enchantments'"></armor-enchantments>
        <spells v-if="type=='Spells'"></spells>
        <maneuvers v-if="type=='Maneuvers'"></maneuvers>
        <potions v-if="type=='Potions'"></potions>
        <gear v-if="type=='Gear'"></gear>
        <wonderous-items v-if="type=='Wonderous Items'"></wonderous-items>
    </div>
</template>
<script>
import {

} from "vuetify/lib";
import Classes from "../rulePages/itemType/classes" 
import Races from "../rulePages/itemType/races" 
import Perks from "../rulePages/itemType/perks"
import Armor from './itemType/armor';
import Feats from './itemType/feats';
import Potions from './itemType/potions';
import Spells from './itemType/spells';
import Weapons from './itemType/weapons';
import Maneuvers from './itemType/maneuvers';
import WeaponEnchantments from './itemType/weaponEnchantments';
import ArmorEnchantments from './itemType/armorEnchantments';
import Gear from "./itemType/gear"
import WonderousItems from "./itemType/wonderousItems"
export default {
    components: {
        Classes,
        Races,
        Perks,
        Feats,
        Weapons,
        Potions,
        Armor,
        Spells,
        Maneuvers,
        WeaponEnchantments,
        ArmorEnchantments,
        Gear,
        WonderousItems,
    },    
    props:{
        //type:String
    },
    data(){
        return{
            type:"Classes",
            perkList:""
        }
    },
    mounted(){
        let params = new URLSearchParams(location.search)
        let type = params.get('type')
        let perkList = params.get('perkList')
        if(perkList) this.perkList = perkList
        if(type){
            this.type = type
            window.scrollTo({top: 0})
        }else{
            window.scrollTo({top: 0})
        }
    },
    watch:{
        $route(){
            let params = new URLSearchParams(location.search)
            let type = params.get('type')
            let perkList = params.get('perkList')
            if(perkList) this.perkList = perkList
            if(type){
                this.type = type
                window.scrollTo({top: 0})
            }else{
                window.scrollTo({top: 0})
            }
        }
    }
    
}
</script>
